import React, { useEffect, useState } from 'react';
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";
import { formatBytes } from "../../../../../helpers/general";
import styles from "./styles";

const CustomPreview = (props) => {
  const {
    fileWithMeta: { cancel, remove, restart },
    meta: { name = '', percent = 0, size = 0, previewUrl, status, duration, validationError },
    customValidationError,
    files,
    isUpload,
    canCancel,
    canRemove,
    canRestart,
    extra: { minSizeBytes },
    setIsUploading,
  } = props

  const theme = useTheme();

  const [preUploadProgress, setPreUploadProgress] = useState(0);

  useEffect(() => {
    let interval;

    const preUploadStatuses = ['preparing', 'getting_upload_params'];
    const shouldStartPreUploadProgress = preUploadStatuses.includes(status) || (status === 'ready' && isUpload);

    if (shouldStartPreUploadProgress) {
      setPreUploadProgress(0);
      interval = setInterval(() => {
        setPreUploadProgress(prev => {
          const next = prev + 15;
          return next >= 100 ? 100 : next;
        });
      }, 50);
    }

    if (status === 'uploading') {
      clearInterval(interval);
      setPreUploadProgress(0);
    }

    if (status === 'done' || status === 'headers_received') {
      setPreUploadProgress(100);
    }

    return () => clearInterval(interval);
  }, [status, isUpload]);

  const currentProgress =
    status === 'done' || status === 'headers_received'
      ? 100
      : status === 'uploading'
        ? percent
        : preUploadProgress;

  const classes = styles({ theme, progress: currentProgress });

  let title = `${name || '?'}`

  let hasError = ['error_upload_params', 'exception_upload', 'aborted'].includes(status) && canRestart || !!customValidationError;

  if (status === 'error_file_size' || status === 'error_validation') {
    hasError = true;
  }

  if (hasError) {
    setIsUploading(false);
  }

  const renderError = () => {
    if (hasError) {
      // the rest of your error logic
      switch (status) {
        case "error_file_size":
          return <span className={classes.errorMessage}>{size < minSizeBytes ? <FormattedMessage id="notifications.uploadPeople.noTravelersError" /> : <FormattedMessage id="dropzone.customPreview.toBigError" />}</span>;
        case "error_validation":
          return <span className={classes.errorMessage}>{String(validationError)}</span>;
        default:
          return <div className={classes.tryAgain} onClick={remove}><FormattedMessage id="dropzone.customPreview.tryAgain" /></div>;
      }
    }
  }

  const renderSelectedFileFailedMessage = () => {
    if (!!customValidationError) {
      return (<span className={classes.errorMessage}>{customValidationError}</span>)
    } else {
      return (<span className={classes.errorMessage}><FormattedMessage id="dropzone.customPreview.responseErrorCode" /></span>)
    }
  }

  //note: 'error_upload' set if upload response has HTTP status code >= 400
  const responseErrorStatus = status === 'error_upload';

  return (
    <div className={hasError || responseErrorStatus || !!customValidationError ? classes.previewError : classes.preview}>
      {
        hasError || responseErrorStatus ?
          <span className={classes.fileRedIcon} />
          :
          <span className={classes.fileIcon} />
      }
      <div
        className={
          !hasError &&
            !responseErrorStatus &&
            isUpload &&
            (status === 'ready' || status === 'preparing' || status === 'getting_upload_params')
            ? classes.content
            : classes.contentNoBar
        }
      >
        {
          hasError &&
          <div className={classes.wrapper}>
            {renderSelectedFileFailedMessage()}
            <span className={classes.cancelRedIcon} onClick={remove} />
          </div>
        }
        <div className={classes.wrapper}>
          <span className={hasError || responseErrorStatus ? classes.titleError : classes.title}>{title}</span>
          {status === 'uploading' && (
            <span className={classes.cancelIcon} onClick={remove} />
          )}
          {!customValidationError && (status === 'ready' || status === 'headers_received') && canRemove && (
            <span className={classes.cancelIcon} onClick={remove} />
          )}
          {status !== 'preparing' && status !== 'getting_upload_params' && status !== 'uploading' && status !== 'ready' && status !== 'headers_received' && canRemove && !hasError && !responseErrorStatus && (
            <span className={classes.icon} />
          )}
        </div>
        {
          renderError()
        }
        {
          !hasError && !responseErrorStatus && (
            <>
              <div>{formatBytes(size)}</div> {/* always visible */}
              {(isUpload && (status === 'ready' || status === 'preparing' || status === 'getting_upload_params')) && (
                <div className={classes.progressBarWrapper}>
                  <div className={classes.progressContainer}>
                    <div className={classes.progressFill} />
                  </div>
                  <div>{currentProgress}%</div>
                </div>
              )}
            </>
          )
        }
      </div>
    </div>
  )
}

export default CustomPreview